import ProductNameProvider from './hooks/useProductName';

import { ProductNameProps } from './@types/ProductNameProps';
import ProductBrand from './handles/ProductBrand';
import ProductReference from './handles/ProductReference';
import ProductNameContainer from './handles/ProductNameContainer';

const ProductName = (props: ProductNameProps) => (
	<ProductNameProvider {...props}>
		<ProductNameContainer>
			<ProductBrand />
		</ProductNameContainer>
		{props.showProductReference && <ProductReference />}
	</ProductNameProvider>
);

export default ProductName;
